import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot/index";
import axios from "axios";

// get Quote 
export const getQuote = createAsyncThunk("getlist-quote", async (data) => {
    const token = localStorage.getItem("authToken")
    try {
        const response = await axios.post(`${baseUrl}cleaningappfunctions/crm/app/v1/getlist-quote`, data, { 
            headers: {
                "auth-token": token,
            }
        },);
        console.log("fassdf a=>>>>>", { response })
        return response;
    } catch (error) {
        console.error('Error fetching quote - ', error);
        throw error;
    }
})


